import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import orderServices from '../../services/orders';

export const getPrinters = createAsyncThunk(
  'order/getPrinters',
  async ({ division, warehouse }) => {
    return await orderServices.getAvailablePrinters(division, warehouse);
  }
);

export const initialState = {
  orderDetails: {},
  orderNotes: [],
  currentPrinter: '',
  availablePrinters: [],
  routeStatus: '',
  postParams: {
    orderNum: '',
    region: '',
  },
  selectedSKUInfo: {
    orderNum: '',
    sku: '',
    pmkey: '',
    warehouseId: '',
    division: '',
    startDate: '',
    endDate: '',
  },
  selectedReturnOrder: {
    OrderNumber: '',
    ShipDate: '',
    AvailablePrinters: [],
    ReturnLines: [
      {
        SkuNumber: '',
        SkuDescription: '',
        SkuCorrection: '',
        SkuNumberCorrection: 0,
        ReturnQuantity: 0,
        ReturnWHS: '',
      },
    ],
  },
  movementData: [],
  relatedOrders: [],
  ticketHistory: [],
  isLoading: false,
  region: '',
};

export const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setRegion: (state, action) => {
      return {
        ...state,
        region: action.payload,
      };
    },
    setParams: (state, action) => {
      state.postParams = {
        orderNum: action.payload.orderNum,
        region: action.payload.region,
      };
    },
    setOrderDetails: (state, action) => {
      state.isLoading = false;
      state.orderDetails = action.payload;
    },
    setOrderNotes: (state, action) => {
      state.isLoading = false;
      state.orderNotes = action.payload;
    },
    setSelectedSku: (state, action) => {
      state.selectedSKUInfo = action.payload;
    },
    setMovementData: (state, action) => {
      state.isLoading = false;
      state.movementData = action.payload;
    },
    setRelatedOrders: (state, action) => {
      state.isLoading = false;
      state.relatedOrders = action.payload;
    },
    setTicketHistory: (state, action) => {
      state.isLoading = false;
      state.ticketHistory = action.payload;
    },
    setReturnedOrder: (state, action) => {
      state.selectedReturnOrder = action.payload;
    },
    setCurrentPrinter: (state, action) => {
      state.currentPrinter = action.payload;
    },
    setRouteStatus: (state, action) => {
      return {
        ...state,
        routeStatus: action.payload,
      };
    },
    resetReturnedOrder: (state) => {
      return {
        ...state,
        selectedReturnOrder: {
          OrderNumber: '',
          ShipDate: '',
          AvailablePrinters: [],
          ReturnLines: [],
        },
      };
    },
    resetOrderDetails: (state) => {
      return {
        ...state,
        isLoading: true,
        orderDetails: {},
        orderNotes: [],
      };
    },
    resetSelectedSku: (state) => {
      return {
        ...state,
        selectedSKUInfo: {
          orderNum: '',
          sku: '',
          pmkey: '',
          warehouseId: '',
          division: '',
          startDate: '',
          endDate: '',
        },
      };
    },
    resetMovementData: (state) => {
      return {
        ...state,
        isLoading: true,
        movementData: [],
      };
    },
    resetHistoryData: (state) => {
      return {
        ...state,
        isLoading: true,
        ticketHistory: [],
      };
    },
    addSkuCorrection: (state, action) => {
      return {
        ...state,
        selectedReturnOrder: {
          ...state.selectedReturnOrder,
          ReturnLines: state.selectedReturnOrder.ReturnLines.map((line, i) =>
            i === action.payload.index
              ? {
                  ...line,
                  SkuCorrection: action.payload.sku,
                  SkuCorrectionQuantity: action.payload.quantity,
                }
              : line
          ),
        },
      };
    },
    clearSkuCorrection: (state, action) => {
      return {
        ...state,
        selectedReturnOrder: {
          ...state.selectedReturnOrder,
          ReturnLines: state.selectedReturnOrder.ReturnLines.map((line, i) =>
            i === action.payload.index
              ? {
                  ...line,
                  SkuCorrection: '',
                  SkuCorrectionQuantity: 0,
                }
              : line
          ),
        },
      };
    },
  },
  extraReducers: {
    [getPrinters.pending]: (state) => {
      return { ...state, isLoading: true };
    },
    [getPrinters.fulfilled]: (state, action) => {
      const printers = Array.isArray(action.payload) ? action.payload : [];
      return {
        ...state,
        isLoading: false,
        availablePrinters: printers,
        selectedReturnOrder: {
          ...state.selectedReturnOrder,
          AvailablePrinters: printers,
        },
      };
    },
    [getPrinters.rejected]: (state, action) => {
      return {
        ...state,
        isLoading: false,
        availablePrinters: [],
        selectedReturnOrder: {
          ...state.selectedReturnOrder,
          AvailablePrinters: [],
        },
      };
    },
  },
});

export const {
  setRegion,
  setParams,
  setOrderDetails,
  setOrderNotes,
  setSelectedSku,
  setMovementData,
  setRelatedOrders,
  setTicketHistory,
  setReturnedOrder,
  setCurrentPrinter,
  setRouteStatus,
  resetReturnedOrder,
  resetOrderDetails,
  resetSelectedSku,
  resetMovementData,
  resetHistoryData,
  addSkuCorrection,
  clearSkuCorrection,
} = { ...orderSlice.actions, getPrinters };

export default orderSlice.reducer;
